import { MobileNavOverlay } from '@/shared/components/AppSidebar/MobileNavOverlay';
import { registerDialog } from '@/shared/lib/dialogRegistry';

/**
 * App-level dialogs — opened from global chrome (e.g. the sidebar account menu),
 * not owned by any single page. They are registered once at bootstrap
 * ({@link registerAppDialogs}, called from `main.tsx`) so they are always
 * available regardless of the current route. Page-owned dialogs register
 * from their narrowest owning route via a feature `useXxxDialogs` hook instead.
 *
 * The composition root is the one layer allowed to import feature dialogs, so
 * these globals live here; add a new app-wide dialog by importing it, augmenting
 * `DialogRegistry`, and registering it below.
 */
declare module '@/shared/lib/dialogRegistry' {
  interface DialogRegistry {
    // Full-screen mobile primary-nav overlay, opened from the mobile top bar.
    'mobile-nav': Record<never, never>;
  }
}

/** Register the app-wide dialogs. Call once at startup, before the app renders. */
export function registerAppDialogs(): void {
  registerDialog('mobile-nav', MobileNavOverlay);
}
